export const AccountCollectionTypes = {
    SHOW_COLLECTION: "SHOW_COLLECTION",
    PAYMENT_COLLECTION: "PAYMENT_COLLECTION",
    DELETE_COLLECTION: "DELETE_COLLECTION",
};
  